import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-perspective-function-large.tsx
/**
* icon.24.perspective.function.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE1LjkyMyA0YS41LjUgMCAwIDEgLjQ3OC4zNTRsNC41NzcgMTVBLjUuNSAwIDAgMSAyMC41IDIwaC0xN2EuNS41IDAgMCAxLS40NzktLjY0NWw0LjU3Ny0xNUEuNS41IDAgMCAxIDguMDc3IDR6TTQuMTc1IDE5aDQuMTE3bC42NTMtNUg1LjcwMXpNOS4zIDE5aDUuNGwtLjY1NC01aC00LjA5em02LjQwOCAwaDQuMTE2bC0xLjUyNi01aC0zLjI0NHpNNy4wNzMgOS41IDYuMDA1IDEzaDMuMDdsLjQ1OS0zLjV6bTMuNDcgMC0uNDU3IDMuNWgzLjgyOGwtLjQ1OC0zLjV6bTMuOTIzIDAgLjQ1OCAzLjVoMy4wN2wtMS4wNjgtMy41em0tNy4wODctMWgyLjI4NWwuNDU4LTMuNUg4LjQ0NnptMy4yOTUgMGgyLjY1MkwxMi44NjggNWgtMS43MzZ6bTMuNjYyIDBoMi4yODVMMTUuNTUzIDVoLTEuNjc1eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58760
*/
const Icon24PerspectiveFunctionLarge = memo(function Icon24PerspectiveFunctionLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M15.923 4a.5.5 0 0 1 .478.354l4.577 15A.5.5 0 0 1 20.5 20h-17a.5.5 0 0 1-.479-.645l4.577-15A.5.5 0 0 1 8.077 4zM4.175 19h4.117l.653-5H5.701zM9.3 19h5.4l-.654-5h-4.09zm6.408 0h4.116l-1.526-5h-3.244zM7.073 9.5 6.005 13h3.07l.459-3.5zm3.47 0-.457 3.5h3.828l-.458-3.5zm3.923 0 .458 3.5h3.07l-1.068-3.5zm-7.087-1h2.285l.458-3.5H8.446zm3.295 0h2.652L12.868 5h-1.736zm3.662 0h2.285L15.553 5h-1.675z"
		})
	});
});
//#endregion
export { Icon24PerspectiveFunctionLarge };

//# sourceMappingURL=icon-24-perspective-function-large.js.map